export default {"src":"/_next/static/media/flag-jp.21086ac6.svg","height":11,"width":16,"blurWidth":0,"blurHeight":0};